export const PRODUCT_NAME_MAX_LENGTH = 250
